import {
  Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef, Input
} from '@angular/core';
import { DataNotificationService } from '@ispm-client/modules/selection-item/services/data-notification.service';
import { isEmpty } from 'lodash';
import { Subject } from 'rxjs/Rx';
import {GetItemsDataService} from "@ispm-client/modules/selection-item/services/get-items-data.service";


@Component({
  selector: 'gen-data-notification',
  templateUrl: './data-notification.component.html',
  styleUrls: ['./data-notification.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class DataNotificationComponent implements OnInit {
  public dataAvailability: boolean = false;
  protected destroyed$: Subject<void> = new Subject();
  public _formId: string;
  @Input() set formId(formId) {
    this._formId = formId;
    if (this._formId) {
      this.showNotification(this._formId);
    }
  }
  get totalSelectedItemList() {
    return this._formId;
  }

  /**
   * triggers when submit the data
   */
  public _updated: boolean;
  @Input() set updated(updated) {
    this._updated = updated;
    if (this._updated) {
      this.dataAvailability = true;
    }
  }
  get updated() {
    return this._updated;
  }

  constructor(private _changeDetector: ChangeDetectorRef,
              private _getItemsDataService: GetItemsDataService,
              private _dataNotificationService: DataNotificationService) {
  }

  ngOnInit() {
  }

  /**
   * DtataBinding is used to get the data. dataAvailability will be true if data exist
   * @param formId
   */
  showNotification(formId) {
    let wrapperIdentifier = null;
      this._getItemsDataService.getFormIdentifier(formId)
        .filter(dataBindings => !isEmpty(dataBindings))
        .switchMap(dataBindings => {
          wrapperIdentifier = dataBindings[0].name;
          return this._dataNotificationService.showDataNotification(formId);
        })
      .takeUntil(this.destroyed$.asObservable())
      .subscribe(data => {
        if ((!isEmpty(data) && !isEmpty(data[wrapperIdentifier])) || this._updated) {
          this.dataAvailability = true;
          this._changeDetector.markForCheck();
          this._changeDetector.detectChanges();
        }
      });
  }

  ngOnDestroy() {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

}
